import Split from './Split';

const Page = {
  Split,
}

export default Page;